import {
  WebFilterPlacementKind,
  WebFilterPlacementSection,
  type WebFilterPlacementKind as PlacementKind,
  type WebFilterPlacementSection as PlacementSection,
} from '@/api/generated/schemas';

export interface PlacementFormValue {
  id: string | null;
  section: PlacementSection;
  kind: PlacementKind;
  isEnabled: boolean;
  labelText: string;
  showPriceFrom: boolean;
  description: string;
  /** Magic File.ID fotky (banner / HP); null = bez fotky. */
  photoFileId: number | null;
  /** Kind-specific: badge, cta, fTypeVariant, … */
  payload: Record<string, unknown>;
}

const KIND_META: {
  kind: PlacementKind;
  section: PlacementSection;
}[] = [
  { kind: WebFilterPlacementKind.MenuBanner, section: WebFilterPlacementSection.MainMenu },
  { kind: WebFilterPlacementKind.MenuTile, section: WebFilterPlacementSection.MainMenu },
  { kind: WebFilterPlacementKind.MenuSpecial, section: WebFilterPlacementSection.MainMenu },
  { kind: WebFilterPlacementKind.MenuLink, section: WebFilterPlacementSection.MainMenu },
  {
    kind: WebFilterPlacementKind.SearchSpecialPeriods,
    section: WebFilterPlacementSection.SearchFilter,
  },
  { kind: WebFilterPlacementKind.SearchTourTypes, section: WebFilterPlacementSection.SearchFilter },
  { kind: WebFilterPlacementKind.HomeFindTour, section: WebFilterPlacementSection.HomePage },
];

export function emptyPlacement(kind: PlacementKind, section: PlacementSection): PlacementFormValue {
  return {
    id: null,
    section,
    kind,
    isEnabled: false,
    labelText: '',
    showPriceFrom: false,
    description: '',
    photoFileId: null,
    payload: kind === WebFilterPlacementKind.SearchTourTypes ? { fTypeVariant: 'normal' } : {},
  };
}

export function emptyPlacements(): PlacementFormValue[] {
  return KIND_META.map(({ kind, section }) => emptyPlacement(kind, section));
}

export function getPlacement(
  placements: PlacementFormValue[],
  kind: PlacementKind
): PlacementFormValue {
  return placements.find((p) => p.kind === kind) ?? emptyPlacement(kind, sectionOf(kind));
}

export function sectionOf(kind: PlacementKind): PlacementSection {
  return KIND_META.find((m) => m.kind === kind)!.section;
}

export function isMenuKind(kind: PlacementKind): boolean {
  return sectionOf(kind) === WebFilterPlacementSection.MainMenu;
}

export function isSearchKind(kind: PlacementKind): boolean {
  return sectionOf(kind) === WebFilterPlacementSection.SearchFilter;
}
